import React, { useState, useEffect } from "react";
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { API_URL } from "./config";
import Swal from "sweetalert2"; 
import XGolifeDashboardComponent from "./components/XGolifeDashboardComponent";

const XGoSwitchView = () => {
  const navigate = useNavigate();
  const [companyNames, setCompanyNames] = useState([]);
  const [branchNames, setBranchNames] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(''); 
  const [selectedBranchId, setSelectedBranchId] = useState(''); 
  const [selectedCompanyName, setSelectedCompanyName] = useState(''); 
  const [selectedBranchName, setSelectedBranchName] = useState(''); 

  useEffect(() => {
    fetchCompanyNames();
  }, []);

  const fetchCompanyNames = async () => {
    try {
      const response = await fetch(`${API_URL}/companysetup/`);
      const data = await response.json();
      console.log("Fetched Company Names:", data);
      setCompanyNames(data);
    } catch (error) {
      console.error("Error fetching company names:", error);
    }
  };

  const fetchBranches = async (companyId) => {
    try {
      const response = await fetch(`${API_URL}/branch/branch_name/company/${companyId}`);
      const data = await response.json();
      console.log("Fetched Branch Names:", data);
      
      localStorage.setItem('selectedBranchName', data[0].branch_name);
      setBranchNames(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const handleCompanyChange = (event) => {
    const selectedId = event.target.value;
    setSelectedCompanyId(selectedId);
    
    const selectedCompany = companyNames.find(company => company.company_id === selectedId);
    if (selectedCompany) {
      setSelectedCompanyName(selectedCompany.name);
      localStorage.setItem('selectedCompanyId', selectedId);
      localStorage.setItem('selectedCompanyName', selectedCompany.name);
      console.log("Company Selected:", selectedCompany.name);
    } else {
      setSelectedCompanyName('');
    }
    
    if (selectedId) {
      fetchBranches(selectedId);
    } else {
      setBranchNames([]);
    }
  };

  const handleBranchChange = (event) => {
    const selectedId = event.target.value;
    setSelectedBranchId(selectedId);
    
    const selectedBranch = branchNames.find(branch => branch.branch_id === selectedId);
    if (selectedBranch) {
      setSelectedBranchName(selectedBranch.branch_name);
      console.log("Branch Selected:", selectedBranch.branch_name);
    } else {
      setSelectedBranchName('');
    }
  };

  const handleGoClick = async () => {
    console.log("Before Navigation:");
    console.log("Selected Company ID:", selectedCompanyId);
    console.log("Selected Branch ID:", selectedBranchId);
  
    if (selectedCompanyId && selectedBranchId) {
      try {
        localStorage.setItem('company_id', selectedCompanyId);
        localStorage.setItem('branch_id', selectedBranchId);
  
        console.log("Storing in local storage:");
        console.log("Company ID:", selectedCompanyId);
        console.log("Branch ID:", selectedBranchId);
  
        Swal.fire({
          title: 'Success!',
          text: `Company ID ${selectedCompanyId} and Branch ID ${selectedBranchId} updated in local storage.`,
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          navigate('/ViewStore');
          setSelectedCompanyId('');
          setSelectedBranchId('');
          setSelectedCompanyName('');
          setSelectedBranchName('');
          setBranchNames([]);
        });
      } catch (error) {
        console.error("Error storing in local storage:", error);
        Swal.fire({
          title: 'Error!',
          text: 'Failed to store selected company and branch details.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Please select a Company ID and a Branch.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  return (
    <XGolifeDashboardComponent>
      <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ padding: 10, flex: 1, marginTop: 20, marginBottom: 20, marginTop: 80 }}>
            <h2 style={{marginBottom: 20}}>Select Company Details</h2>
            <Form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'start' }}>
              <Form.Group controlId="companySelect" style={{ marginBottom: '20px', width: '500px' }}>
                <Form.Label style={{ textAlign: 'start' }}>Select Company Name</Form.Label>
                <Form.Select 
                  value={selectedCompanyId} 
                  onChange={handleCompanyChange}
                  style={{ backgroundColor: 'lightgray', border: 'none' }} // Light gray background, no border
                >
                  <option value="">Select Company Name</option>
                  {companyNames.map(company => (
                    <option key={company.company_id} value={company.company_id}>
                      {company.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              
              {selectedCompanyId && (
                <Form.Group controlId="branchSelect" style={{ marginBottom: '20px', width: '500px' }}>
                  <Form.Label style={{ textAlign: 'start' }}>Select Branch Name</Form.Label>
                  <Form.Select 
                    value={selectedBranchId} 
                    onChange={handleBranchChange}
                    style={{ backgroundColor: 'lightgray', border: 'none' }} // Light gray background, no border
                  >
                    <option value="">Select a Branch</option>
                    {branchNames.map(branch => (
                      <option key={branch.branch_id} value={branch.branch_id}>
                        {branch.branch_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              <Button 
                variant="primary" 
                onClick={handleGoClick}
                style={{ marginTop: "30px", paddingLeft: 50, paddingRight: 50, backgroundColor: '#FFC000', border: 'none', color: '#000'}}
              >
                Go
              </Button>
            </Form>

            <div style={{ marginTop: "20px", textAlign: "center" }}>
              {selectedCompanyName && <p><strong>Selected Company:</strong> {selectedCompanyName}</p>}
              {selectedBranchName && <p><strong>Selected Branch:</strong> {selectedBranchName}</p>}
            </div>
          </div>
        </div>
      </div>
    </XGolifeDashboardComponent>
  );
};

export default XGoSwitchView;